// 261023 E3-P3h4d1 — chữ của «truy vết bước ③» (THUẦN, không antd/react). Nguồn: BE GET scripts → `localizeTrace` mỗi dòng.
// 🔴 Hai loại bằng chứng KHÔNG được nhầm: biên nhận chỉ chứng minh THAM CHIẾU («cảnh này lúc viết đã nhận các tên này»), KHÔNG chứng minh NGUYÊN NHÂN («lỗi do bước ③»).
// Vì vậy chữ luôn nói «chưa chứng minh lỗi do bước ③», và không bao giờ có câu «máy đã sửa ở ③» (máy không sửa ngược — chỉ mở đúng chỗ để người nhờ Trợ lý).
import type { LocalizeTrace, LocalizeTraceEntity } from '../../../types/adaptation';
import { redactMoney } from './moneyRedact';

export interface TraceLine {
  text: string;
  /** Không có biên nhận dùng được (tập cũ, hoặc cảnh không nằm trong biên nhận). */
  missing: boolean;
  /** Có thực thể của cảnh mà bước ③ đã đổi từ lúc viết. */
  changed: boolean;
}

export const TRACE_MISSING_TEXT = 'Thiếu biên nhận: tập này viết trước khi máy ghi lại bước ③ đã dùng, nên chưa lần được tên nào.';
const SCENE_MISSING_TEXT = 'Cảnh này không có trong biên nhận bước ③ (viết thêm hoặc đổi sau lúc viết) — chưa lần được.';
const NO_NAME_TEXT = 'Lúc viết, cảnh này không nhận tên nào từ bước ③.';
const NOT_CAUSE = ' Đây chỉ cho thấy cảnh có dùng các tên này — chưa chứng minh lỗi do bước ③.';
const MAX_NAMES = 5;

const clean = (s: string | null | undefined): string => redactMoney(s).trim();
const namesOf = (list: LocalizeTraceEntity[]): string => {
  const shown = list.slice(0, MAX_NAMES).map((e) => clean(e.name)).filter(Boolean);
  return shown.join(', ') + (list.length > MAX_NAMES ? ', …' : '');
};
const changeOf = (e: LocalizeTraceEntity): string => (e.present ? `${clean(e.name)} → ${clean(e.nowName ?? e.name)}` : `${clean(e.name)} (không còn)`);

/**
 * Một dòng chữ cho MỘT cảnh (hoặc cả tập khi `sceneId` null). `trace` vắng (BE cũ) ⇒ null ⇒ giữ hiển thị cũ.
 * Nhân vật liệt kê trước, bối cảnh sau; tối đa 5 tên rồi «…».
 */
export const traceLineOf = (trace: LocalizeTrace | null | undefined, sceneId: string | null): TraceLine | null => {
  if (!trace) return null;
  if (trace.state !== 'RECEIPT') return { text: TRACE_MISSING_TEXT, missing: true, changed: false };
  let ents: LocalizeTraceEntity[];
  if (sceneId) {
    const scene = (trace.scenes ?? []).find((s) => s.scenePlanId === sceneId);
    if (!scene) return { text: SCENE_MISSING_TEXT, missing: true, changed: false };
    const ids = new Set(scene.entityIds);
    ents = (trace.entities ?? []).filter((e) => ids.has(e.id));
  } else {
    ents = trace.entities ?? [];
  }
  ents = [...ents.filter((e) => e.kind === 'character'), ...ents.filter((e) => e.kind !== 'character')];
  if (!ents.length) return { text: NO_NAME_TEXT, missing: false, changed: false };
  const moved = ents.filter((e) => e.changed);
  const scope = sceneId ? 'cảnh này' : 'tập này';
  const head = `Lúc viết, ${scope} nhận các tên ở bước ③: ${namesOf(ents)}.`;
  const tail = moved.length ? ` Bước ③ đã đổi từ lúc viết: ${moved.slice(0, MAX_NAMES).map(changeOf).join('; ')}.` : '';
  return { text: head + NOT_CAUSE + tail, missing: false, changed: moved.length > 0 };
};
